module.exports = __webpack_public_path__ + "media/images/icons/transfer-477fb5a0a2aa3b9a784c7c303edbc1e1.svg";